import React from "react";

const QuestionSolving = () => {
  return <div>QuestionSolving</div>;
};

export default QuestionSolving;
